import { Button, Col, Divider, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import offerAPI from '~/api/OfferAPI';
import userAPI from '~/api/UserAPI';
import { IMAGES } from '~/assets/assetsPath';
import RefillNowModal from '~/components/FormRefillNow';
import config from '~/config';
import styles from './TopUp.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useSelector } from 'react-redux';
import CancelModal from '~/components/FormCancel';
import { LeftOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);

const TopUp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    const [amount, setAmount] = useState(0);
    const [isShowRefillNowModal, setIsShowRefillNowModal] = useState(false);

    const [listOffer, setListOffer] = useState([]);
    const [wallet, setWallet] = useState(0);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);
    const onAgreeLogin = () => {
        navigate(config.routes.login);
        localStorage.setItem('navigateAfterLogin', location.pathname + location.search);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };
    const handleGetListOffer = async (list, page) => {
        try {
            const offers = list;
            let final = [];
            const params = {
                fields: '["$all"]',
                order: '[["from", "asc"]]',
                limit: pagination.limit,
                page: page,
            };
            const res = await offerAPI.getListOfferAPI(params);

            if (res.code === 200) {
                offers.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (offers?.length) {
                final = [...new Map(offers.map((item) => [item['id'], item])).values()];
            }

            setListOffer(final);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListOffer(listOffer, nextPage);
        } catch (err) {
            console.log(err);
        }
    };

    const onAgreeRefillNow = async () => {
        setIsShowRefillNowModal(false);
        // setIsLoading(true)
        try {
            const params = {
                amount: parseInt(amount),
            };
            const res = await userAPI.deposit(params);
            if (res.code === 200) {
                setWallet(Math.ceil(parseInt(wallet) + parseInt(amount)));
                notification.open({
                    message: 'You have sent a deposit request, we will contact you within 24 hours.',
                    duration: 1.5,
                    placement: 'top',
                });
            }
            navigate(config.routes.historyTopUp);
            // setIsLoading(false)
        } catch (err) {
            console.log(err);
        }
        // navigate(config.routes.contact)
    };

    const handelShowRefillNowModal = () => {
        if (isLogin) {
            setIsShowRefillNowModal(true);
        } else {
            setIsShowRequireLogin(true);
        }
    };

    const onRejectRefillNow = () => {
        setIsShowRefillNowModal(false);
    };

    const renderExpireDay = (item) => {
        switch (item?.time_type) {
            case 'DAY':
                return `${item?.expired} date`;
            case 'MONTH':
                return `${item?.expired} month`;
            case 'YEAR':
                return `${item?.expired} year`;
            default:
                return;
        }
    };

    useEffect(() => {
        handleGetListOffer(listOffer, pagination.page);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangNapTien');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Request to buy card
                        </p>
                        <p className={cx('btn')} onClick={() => navigate(config.routes.historyTopUp)}>
                            Transaction history
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>Card purchase request</Row>
                    <div className={cx('right_container')}>
                        <Row className={cx('banner_footer')}>
                            <img src={IMAGES.BannerTopUp} alt="" style={{ width: '100%', borderRadius: '15px' }} />
                        </Row>
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        <Row className={cx('table_container')}>
                            {/* <Row className={cx('tab_section')}>
                                <div className={cx('tab_item', 'tab_item_selected')}>Service Limit</div>
                            </Row> */}
                            {listOffer?.map((item, index) => {
                                return (
                                    <Row
                                        className={cx('item')}
                                        key={index}
                                        onClick={() => navigate(`/thong-tin-nap-tien/${item?.id}`)}
                                    >
                                        <Col xs={13} xl={9}>
                                            <Row className={cx('price')}>{item.title}</Row>
                                            <Row className={cx('receive')}>
                                                Receive &nbsp;
                                                <span className={cx('receive')}>
                                                    {(parseInt(item.from) * item.offer) / 100 / 1000000} million VND
                                                </span>
                                            </Row>
                                            {/* <Row className={cx('receive')}>Expiration date {renderExpireDay(item)}</Row> */}
                                        </Col>
                                        <Col xs={1}>
                                            <Row justify="center">
                                                <Divider
                                                    type="vertical"
                                                    style={{
                                                        minHeight: '50px',
                                                        borderLeft: '2px solid rgba(0,0,0,.06)',
                                                    }}
                                                />
                                            </Row>
                                        </Col>
                                        <Col xs={5}>
                                            <Row
                                                justify="center"
                                                className={cx('receive')}
                                                style={{ textAlign: 'center' }}
                                            >
                                                Expiration date {renderExpireDay(item)}
                                            </Row>
                                        </Col>
                                        <Col xs={1}>
                                            <Row justify="center">
                                                <Divider
                                                    type="vertical"
                                                    style={{
                                                        minHeight: '50px',
                                                        borderLeft: '2px solid rgba(0,0,0,.06)',
                                                    }}
                                                />
                                            </Row>
                                        </Col>
                                        <Col xs={4} xl={8}>
                                            <Row justify="center" className={cx('endow')}>
                                                Offer: {item.offer}%
                                            </Row>
                                        </Col>
                                        {/* <Col xs={5}>
                                            <Button
                                                className={cx('btn_top_up')}
                                                // loading={isLoading}
                                                onClick={() => {
                                                    handelShowRefillNowModal();
                                                    setAmount(item.from);
                                                }}
                                            >
                                                Buy now
                                            </Button>
                                        </Col> */}
                                    </Row>
                                );
                            })}
                        </Row>
                        {pagination.page < pagination.total_page && (
                            <Row justify="center" style={{ marginTop: '30px' }}>
                                <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                    see more
                                </div>
                            </Row>
                        )}
                        {/* <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} /> */}
                        {/* <Row className={cx('banner_footer')}>
                            <img src={IMAGES.BannerTopUp} alt="" style={{ width: '100%' }} />
                        </Row> */}
                        {isShowRefillNowModal && (
                            <Modal
                                centered
                                visible={isShowRefillNowModal}
                                onCancel={onRejectRefillNow}
                                maskClosable={false}
                                footer={null}
                                className="otp-modal"
                                width={480}
                            >
                                <div style={{ padding: '30px 10px 0px 10px' }}>
                                    <RefillNowModal
                                        onRejectRefillNow={onRejectRefillNow}
                                        onAgreeRefillNow={onAgreeRefillNow}
                                        text="Are you sure you want to deposit money?"
                                    />
                                </div>
                            </Modal>
                        )}
                        {isShowRequireLogin && (
                            <Modal
                                centered
                                visible={isShowRequireLogin}
                                onCancel={() => setIsShowRequireLogin(false)}
                                maskClosable={false}
                                footer={null}
                                className="otp-modal"
                                width={500}
                            >
                                <div style={{ padding: '20px 20px' }}>
                                    <CancelModal
                                        onAgreeCancel={onAgreeLogin}
                                        onRejectCancel={onRejectLogin}
                                        text="Do you want to log in to continue?"
                                    />
                                </div>
                            </Modal>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopUp;
